import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DiscountsService} from "@services";
import {Discount} from "@model";

export const DiscountsDetailsResolver: ResolveFn<Observable<Discount> |
  Promise<Discount> | Discount> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   discountsService: DiscountsService = inject(DiscountsService)): Observable<Discount> |
    Promise<Discount> | Discount => {
    if (route.queryParams['discountId'] && route.queryParams['organiserId']) {
      return discountsService.fetchDiscount(+route.queryParams['discountId'], +route.queryParams['organiserId']);
    } else if (route.queryParams['discountId']) {
      return discountsService.fetchDiscount(+route.queryParams['discountId']);
    } else {
      return new Discount();
    }
  }
